import { PartialMap } from '@/types'

interface CsvExporterOptions {
  convertNullToEmptyString: boolean,
  includeHeaderLine: boolean
}

const maybe_csv_escape = (s: string) => {
  const t = s.replace(/"/g, '""') // repeat double quotes
  if (t.includes(';')) {
    return '"' + t + '"' // wrap
  }
  return t
}

const csv_value = <T>(rawValue: T, convertNullToEmptyString: boolean) => {
  if (rawValue === null && convertNullToEmptyString) return ''
  const value = String(rawValue)
  return maybe_csv_escape(value)
}

export default class CsvExporter {

  static convert<T> (rows: T[], keys: (keyof T)[], headerMap: PartialMap<T, string> = {},
    options?: Partial<CsvExporterOptions>): string
  {
    const lines: string[] = []
    const headers: string[] = []
    if (options?.includeHeaderLine ?? true) {
      for (const field of keys) headers.push(String(headerMap[field] ?? field))
      lines.push(headers.join(';'))
    }
    for (const row of rows) {
      const items = keys.map((key) => csv_value(row[key], options?.convertNullToEmptyString ?? false))
      const line = items.join(';')
      lines.push(line)
    }
    const csvContent = lines.join('\n').replace(/(^\[)|(]$)/gm, '')
    const preamble = 'data:application/octetstream;base64,'
    return preamble + btoa(unescape(encodeURIComponent(csvContent)))
  }

  static download (data: string, filename: string) {
    const link = document.createElement('a')
    link.setAttribute('href', data)
    link.setAttribute('download', `${ filename }.csv`)
    link.click()
  }

}
